export default __webpack_public_path__ + "static/soc2-type2-audit-timeline-case-study-6ba5e299917843f6c428b2d3ff0280f0.jpg";